<template>
    <div>
        <div v-if="!show_historico">
            <div class="row px-3 mb-3 justify-content-between">
                <strong>Endereço Atual</strong>
                <a
                    class="font-weight-light font-italic"
                    role="button"
                    @click="show_historico = true"
                >
                    <i class="fas fa-history"></i> Histórico de Endereços
                </a>
            </div>
            <EnderecoTable :item="item" />
            <strong>Atualizar ou Cadastrar um novo endereço</strong>

            <div class="row">
                <div class="col-md-12 p-3 d-flex align-items-center">
                    <div class="float-left mr-2">
                        <toggle-button
                            :sync="true"
                            color="#5685D8"
                            id="abrigo"
                            name="abrigo"
                            v-model="item.endereco.abrigo"
                        />
                    </div>
                    Endereço de Acolhimento Institucional?
                </div>
            </div>
            <form @submit.prevent="submit" ref="addItem">
                <form-endereco
                    :item="item.endereco"
                    v-if="!item.endereco.situacao_rua"
                />

                <div class="row mt-3 border-top" v-else>
                    <h5 class="col-md-12 font-weight-bold mt-3">
                        Referência para localização do Usuário/Família em
                        Situação de Rua
                    </h5>

                    <div class="col-md-12 p-3 d-flex align-items-center">
                        <div class="float-left mr-2">
                            <toggle-button
                                :sync="true"
                                color="#5685D8"
                                id="situacao_rua"
                                name="situacao_rua"
                                v-model="item.endereco.situacao_rua"
                                disabled="disabled"
                            />
                        </div>
                        Endereço de Usuário/Família em Situação de Rua.
                    </div>

                    <form-input
                        v-model="item.endereco.referencia_endereco"
                        label="Descrição da referência"
                        :required="true"
                    />
                </div>

                <!--
                Regra temporariamente desativada:
                v-if="
                item.estado_cadastral_id != 4 &&
                item.estado_cadastral_id != 5
                "
                -->

                <div
                    class="row pt-4 px-2 d-flex justify-content-end align-items-center"
                >
                    <form-toggle
                        grid="9"
                        class="d-flex justify-content-end"
                        mt="0"
                        v-model="item.cadastrarEndereco"
                        label="Salvar como um novo endereço?"
                    />
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save"></i>
                        Salvar
                    </button>
                </div>
            </form>
        </div>
        <div v-else>
            <Historico
                @voltar="show_historico = false"
                :familia-id="$route.params.id"
            />
        </div>
    </div>
</template>
<script>
import Historico from "../../historico/Endereco";
import EnderecoTable from "./EnderecoTable";
export default {
    components: { Historico, EnderecoTable },
    props: ["item", "localidade"],
    data() {
        return {
            endereco: {},
            show_historico: false,
            logradouros: [],
            localidades: [],
            localidade_bairro: "",
            logradouro: "",
            loading: false,
            loadingLogradouros: false,
        };
    },
    watch: {
        item() {
            this.setLocalidade();
        },
    },
    mounted() {
        this.setLocalidade();
    },
    methods: {
        setLocalidade() {
            this.localidade_bairro = this.localidade
                ? this.localidade.nome_localidade
                : null;
            this.logradouro = this.item.endereco.logradouro
                ? this.item.endereco.logradouro.nome_logradouro
                : null;
            this.localidades = Array.from(this.localidade);
        },
        submit() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            this.item.localidade = this.localidade_bairro;
            this.item.logradouro = this.logradouro;
            this.$emit("submit");
            ladda.stop();
        },
      
    },
};
</script>
